<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">Add New LR</h1>
        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">
            Manage LR
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add New LR</li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-xl-12">
      <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
        <h4 class="text-dark fw-bold mb-0">Add LR</h4>
        <p style="font-size: 13px">Please fill out the following details.</p>
      </div>
      <form [formGroup]="addNewLR">
        <div class="contentbox mb-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Basic Details</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <!-- Manual Lr No -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="manualLR_noctrl">Manual LR no.</label>
                      <div class="d-flex col align-items-center">
                        <input
                          type="text"
                          class="form-control me-1 shadow-none"
                          id="manualLR_noctrl"
                          placeholder="Enter LR no."
                          formControlName="manualLR_no"
                          (focus)="onManualLRFocus()"
                          (blur)="onManualLRBlur()"
                        />

                      </div>
                      <span
                        class="text-danger"
                        *ngIf="
                          addNewLR.get('manualLR_no')?.touched &&
                          addNewLR.get('manualLR_no')?.hasError('duplicate')
                        "
                      >
                        Manual LR number already exists
                      </span>
                    </div>
                  </div>

                  <!-- Supervisor Name -->

                  <div
                    class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3"
                    *ngIf="userSessionData?.user_role_id[0] == 1"
                  >
                    <div class="form-group accountsinp mb-3">
                      <label for="">Supervisor Name </label>
                      <select
                        id="supervisornamectrl"
                        formControlName="supervisorname"
                        placeholder="Select Status"
                        class="form-control shadow-none"
                      >
                        <option selected disabled value="">
                          --Select Supervisor Name--
                        </option>
                        <option
                          *ngFor="let s of superVisor"
                          value="{{ s._id }}"
                        >
                          {{ s.full_name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Company name-->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="clientListctrl"
                        >Company Name<sup class="text-danger">*</sup></label
                      >

                      <select
                        id="clientListctrl"
                        formControlName="clientList"
                        placeholder="Select Client Name"
                        class="form-control shadow-none"
                        (change)="onKeyClientName($event)"
                      >
                        <option disabled value="">
                          --Select Company Name--
                        </option>
                        <option
                          *ngFor="let cl of clientList"
                          value="{{ cl?._id }}"
                        >
                          {{ cl?.clientName }}
                        </option>
                      </select>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.clientList.invalid &&
                          (ff.clientList.touched || submitLRClicked)
                        "
                      >
                        Please select Company Name
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contentbox mb-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Consignee & Consignor</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <!-- Vehicle Number -->
                  <div class="col-lg-6 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="ConsignorNamectrl"
                        >Consignor Name<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        class="form-control me-1 shadow-none"
                        id="ConsignorNamectrl"
                        placeholder="Enter Consignor Name"
                        formControlName="ConsignorName"
                        [matAutocomplete]="autoConsignorName"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.ConsignorName.invalid &&
                          (ff.ConsignorName.touched || submitLRClicked)
                        "
                      >
                        Please enter Consignor Name
                      </span>
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoConsignorName="matAutocomplete"
                        (optionSelected)="getCompanyAddress($event)"
                      >
                        <mat-option
                          *ngFor="let option of clientList"
                          [value]="option.clientName"
                        >
                          {{ option.clientName }}
                        </mat-option>
                      </mat-autocomplete>

                      <!-- </div> -->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="ConsignorAddressctrl"
                        >Consignor Address<sup class="text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        id="ConsignorAddressctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Consignor Address"
                        formControlName="ConsignorAddress"
                        (keyup)="onKeyConsignorAddress($event)"
                        [matAutocomplete]="autoConsignorAddress"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoConsignorAddress="matAutocomplete"
                      >
                      </mat-autocomplete>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.ConsignorAddress.invalid &&
                          (ff.ConsignorAddress.touched || submitLRClicked)
                        "
                      >
                        Please enter Consignor Address
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="ConsigneeNamectrl"
                        >Consignee Name<sup class="text-danger">*</sup></label
                      >
                      <!-- <div class="d-flex align-items-center"> -->
                      <input
                        type="text"
                        class="form-control me-1 shadow-none"
                        id="ConsigneeNamectrl"
                        placeholder="Enter Consignee Name"
                        formControlName="ConsigneeName"
                        [matAutocomplete]="autoConsigneeAddress"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoConsigneeAddress="matAutocomplete"
                        (optionSelected)="getCompanyAddressCon($event)"
                      >
                        <mat-option
                          *ngFor="let option of clientList"
                          [value]="option.clientName"
                        >
                          {{ option.clientName }}
                        </mat-option>
                      </mat-autocomplete>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.ConsigneeName.invalid &&
                          (ff.ConsigneeName.touched || submitLRClicked)
                        "
                      >
                        Please enter Consignee Name
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="ConsigneeAddressctrl"
                        >Consignee Address<sup class="text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        id="ConsigneeAddressctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Consignee Address"
                        formControlName="ConsigneeAddress"
                        (keyup)="onKeyConsigneeAddress($event)"
                        [matAutocomplete]="autoConsigneeAddress"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoConsigneeAddress="matAutocomplete"
                      >
                      </mat-autocomplete>

                      <span
                        class="text-danger"
                        *ngIf="
                          ff.ConsigneeAddress.invalid &&
                          (ff.ConsigneeAddress.touched || submitLRClicked)
                        "
                      >
                        Please enter Consignee Address
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Vehicle & Trip Details</h4>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="VehicleNoctrl"
                      >Vehicle No.<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      id="VehicleNoctrl"
                      class="form-control shadow-none"
                      placeholder="Enter Vehicle No."
                      formControlName="VehicleNo"
                      [matAutocomplete]="autoVehicleNum"
                    />

                    <mat-autocomplete
                      autoActiveFirstOption
                      #autoVehicleNum="matAutocomplete"
                      (optionSelected)="getVehicleTypeFromNumber($event)"
                    >
                      <mat-option
                        *ngFor="let option of filteredVehicleNo | async"
                        [value]="option"
                      >
                        {{ option }}
                      </mat-option>
                    </mat-autocomplete>

                    <span
                      class="text-danger"
                      *ngIf="
                        ff.VehicleNo.invalid &&
                        (ff.VehicleNo.touched || submitLRClicked)
                      "
                    >
                      Please enter Vehicle number
                    </span>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="vehicleTypectrl">Vehicle Type</label>
                    <input
                      type="text"
                      id="vehicleTypectrl"
                      class="form-control shadow-none"
                      placeholder="Enter Vehicle Type"
                      formControlName="vehicleType"
                      (keyup)="onKeyVehicleType($event)"
                      [matAutocomplete]="autoVehicleType"
                    />
                    <mat-autocomplete
                      autoActiveFirstOption
                      #autoVehicleType="matAutocomplete"
                    >
                      <mat-option
                        *ngFor="let option of filteredVehicleTypes | async"
                        [value]="option"
                      >
                        {{ option }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="datectrl"
                      >Date<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="date"
                      id="datectrl"
                      class="form-control shadow-none"
                      placeholder="Enter Date"
                      formControlName="date"
                      (change)="onKeyDate($event)"
                      [min]="isSupervisor ? yesterday : null"
                      [max]="isSupervisor ? today : null"
                    />

                    <span
                      class="text-danger"
                      *ngIf="
                        ff.date.invalid && (ff.date.touched || submitLRClicked)
                      "
                    >
                      Please enter date
                    </span>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="fromctrl"
                      >From<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      id="fromctrl"
                      class="form-control shadow-none"
                      placeholder="Enter From"
                      formControlName="from"
                      (keyup)="onKeyFrom($event)"
                    />
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.from.invalid && (ff.from.touched || submitLRClicked)
                      "
                    >
                      Please enter value
                    </span>
                  </div>
                </div>

                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="toctrl"
                      >To<sup class="text-danger">*</sup></label
                    >
                    <input
                      type="text"
                      id="toctrl"
                      class="form-control shadow-none"
                      placeholder="Enter To"
                      formControlName="to"
                      (keyup)="onKeyTo($event)"
                    />
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.to.invalid && (ff.to.touched || submitLRClicked)
                      "
                    >
                      Please enter value
                    </span>
                  </div>
                </div>

                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Trip Starting Date<sup class="text-danger">*</sup></label
                    >
                    <div class="d-flex align-items-center">
                      <input
                        type="date"
                        class="form-control shadow-none"
                        placeholder="Enter Start Time"
                        id="tripSDatectrl"
                        formControlName="tripSDate"
                      />
                    </div>
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.tripSDate.invalid &&
                        (ff.tripSDate.touched || submitLRClicked)
                      "
                    >
                      Please enter Trip Starting Date
                    </span>
                  </div>
                </div>

                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Trip End Date</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="date"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter End Time"
                        id="c"
                        formControlName="tripEDate"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contentbox mb-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Compliance & Value</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="GSTINctrl"
                        >GSTIN<sup class="text-danger">*</sup></label
                      >
                      <div class="align-items-center">
                        <input
                          type="text"
                          class="form-control me-1 shadow-none"
                          id="GSTINctrl"
                          placeholder="Enter GSTIN"
                          formControlName="GSTIN"
                          (keyup)="onKeyGSTIN($event)"
                        />
                        <span
                          class="text-danger"
                          *ngIf="ff.GSTIN.errors?.['required'] && (ff.GSTIN.touched || submitLRClicked)"
                        >
                          Please enter GST number
                        </span>

                        <span
                          class="text-danger"
                          *ngIf="(ff.GSTIN.errors?.['minlength'] || ff.GSTIN.errors?.['maxlength']) && (ff.GSTIN.touched || submitLRClicked)"
                        >
                          Only 15 characters are allowed in the GSTIN
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="RoadPermitNoctrl"
                        >Road Permit No.<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="RoadPermitNoctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Road Permit No."
                        formControlName="RoadPermitNo"
                        (keyup)="onKeyRoadPermitNo($event)"
                        [matAutocomplete]="autoVehiclePermit"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoVehiclePermit="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="
                            let option of filteredVehicleRoadPermit | async
                          "
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.RoadPermitNo.invalid &&
                          (ff.RoadPermitNo.touched || submitLRClicked)
                        "
                      >
                        Please enter road permit no.
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="DLYctrl"
                        >DLY<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="DLYctrl"
                        class="form-control shadow-none"
                        placeholder="Enter DLY"
                        formControlName="DLY"
                        (keyup)="onKeyDLY($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.DLY.invalid && (ff.DLY.touched || submitLRClicked)
                        "
                      >
                        Please enter DLY
                      </span>
                    </div>
                  </div>
                  <!-- Order Id -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="orderIdctrl">Order Id</label>
                      <div class="d-flex align-items-center">
                        <input
                          type="text"
                          class="form-control me-1 shadow-none"
                          id="orderIdctrl"
                          placeholder="Enter order Id."
                          formControlName="orderId"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="DeclaredValuectrl">Declared Value</label>
                      <input
                        disabled
                        type="text"
                        id="DeclaredValuectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Declared Value"
                        formControlName="DeclaredValue"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Transport -->
        <div class="contentbox mb-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Transporter & Driver</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="transportorNamectrl"
                        >Transporter Name<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="transportorNamectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Transporter Name"
                        formControlName="transportorName"
                        (keyup)="onKeyTransportorName($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.transportorName.invalid &&
                          (ff.transportorName.touched || submitLRClicked)
                        "
                      >
                        Please enter transportor name
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="transportorMobilectrl"
                        >Transporter Mobile<sup class="text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        id="transportorMobilectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Transporter Mobile"
                        formControlName="transportorMobile"
                        (keyup)="onKeyTransportorMobile($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.transportorMobile.invalid &&
                          (ff.transportorMobile.touched || submitLRClicked)
                        "
                      >
                        Please enter transportor Mobile number
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="driverNamectrl">Driver Name</label>
                      <input
                        type="text"
                        id="driverNamectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Driver Name"
                        formControlName="driverName"
                        [matAutocomplete]="autoDriverName"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoDriverName="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let option of filteredDriverName | async"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.driverName.invalid &&
                          (ff.driverName.touched || submitLRClicked)
                        "
                      >
                        Please Select Driver Name
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="driverMobilectrl">Driver Mobile</label>
                      <input
                        type="text"
                        id="driverMobilectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Driver Mobile"
                        formControlName="driverMobile"
                        [matAutocomplete]="autoDriverNumber"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoDriverNumber="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let option of filteredDriverNumber | async"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment -->
        <div class="contentbox mb-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Payment Details</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for=""
                        >Vehicle Rate<sup class="text-danger">*</sup></label
                      >
                      <div class="align-items-center">
                        <input
                          type="number"
                          class="form-control me-1 shadow-none"
                          placeholder="Vehicle Rate"
                          id="vehicleRatectrl"
                          formControlName="vehicleRate"
                        />
                        <span
                          class="text-danger"
                          *ngIf="
                            ff.vehicleRate.invalid &&
                            (ff.vehicleRate.touched || submitLRClicked)
                          "
                        >
                          Please enter Vehicle Rate
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for=""
                        >Advance<sup class="text-danger">*</sup></label
                      >
                      <div class="align-items-center">
                        <input
                          type="number"
                          class="form-control me-1 shadow-none"
                          placeholder="Advance"
                          id="advancectrl"
                          formControlName="advance"
                        />
                        <span
                          class="text-danger"
                          *ngIf="
                            ff.advance.invalid &&
                            (ff.advance.touched || submitLRClicked)
                          "
                        >
                          Please enter Advance
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for=""
                        >Balance Paid<sup class="text-danger">*</sup></label
                      >
                      <div class="align-items-center">
                        <input
                          type="number"
                          class="form-control me-1 shadow-none"
                          placeholder="Balance Paid"
                          (change)="onFocusOutEvent($event)"
                          id="balancePaidctrl"
                          formControlName="balancePaid"
                        />
                        <span
                          class="text-danger"
                          *ngIf="
                            ff.balancePaid.invalid &&
                            (ff.balancePaid.touched || submitLRClicked)
                          "
                        >
                          Please enter Paid Balance
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="">Actual Balance</label>
                      <div class="align-items-center">
                        <input
                          type="number"
                          class="form-control me-1 shadow-none"
                          placeholder="Actual Balance"
                          disabled
                          id="balancectrl"
                          formControlName="balance"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="form-group accountsinp mb-3">
                      <label>TDS</label>
                      <input
                        type="number"
                        class="form-control shadow-none"
                        placeholder="TDS"
                        id="TDSctrl"
                        formControlName="TDS"
                      />
                    </div>
                  </div>

                  <!-- Munsipal Amount -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="form-group accountsinp mb-3">
                      <label>Munsipal Amount</label>
                      <input
                        type="number"
                        class="form-control shadow-none"
                        placeholder="Munsipal Amount"
                        id="munsipalAmountctrl"
                        formControlName="munsipalAmount"
                      />
                    </div>
                  </div>

                  <!-- Final Amount (MANUAL INPUT) -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="form-group accountsinp mb-3">
                      <label>Final Amount</label>
                      <input
                        type="number"
                        class="form-control shadow-none"
                        placeholder="Final Amount"
                        id="finalAmountctrl"
                        formControlName="finalAmount"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Freight & Expenses -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-12 border-bottom pb-3 mb-3 border-gray">
              <h4 class="text-dark fw-bold mb-0">Freight & Expenses</h4>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="quantityctrl"
                  >Quantity/Weight<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="quantityctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Quantity/Weight"
                  formControlName="quantity"
                  (keyup)="onKeyQuantity($event)"
                  (change)="focusonWeight($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="
                    ff.quantity.invalid &&
                    (ff.quantity.touched || submitLRClicked)
                  "
                >
                  Please enter quantity
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="Frieghtctrl"
                  >Freight<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  class="form-control me-1 shadow-none"
                  placeholder="Enter Freight Value"
                  id="Frieghtctrl"
                  formControlName="Frieght"
                  (keyup)="onKeyFrieght($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="
                    ff.Frieght.invalid &&
                    (ff.Frieght.touched || submitLRClicked)
                  "
                >
                  Please enter fright no.
                </span>
              </div>
            </div>

            <!-- Number of Articles -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Other payment</label>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="Other payment"
                  id="otherPaymentctrl"
                  formControlName="otherPayment"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.otherPayment.invalid && ff.otherPayment.touched"
                >
                  Only numbers should be accepted
                </span>

                <input
                  type="text"
                  class="form-control mt-3 shadow-none"
                  placeholder="Other payment Description"
                  id="otherPaymentDescriptionctrl"
                  formControlName="otherPaymentDescription"
                />
              </div>
            </div>

            <!-- Detention -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Detention</label>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="Detention"
                  id="detentionctrl"
                  formControlName="detention"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.detention.invalid && ff.detention.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>

            <!-- Labour -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Labour Loading</label>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="Labour Loading"
                  id="labourLoadctrl"
                  formControlName="labourLoad"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.labourLoad.invalid && ff.labourLoad.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Labour Unloading</label>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="Labour Unloading"
                  id="labourUnloadctrl"
                  formControlName="labourUnload"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.labourUnload.invalid && ff.labourUnload.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>
            <!-- Loading Slip Attachment -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label>Loading Slip Attachment</label>
              </div>

              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <div class="d-flex align-items-center gap-2">
                  <!-- Input showing last uploaded file -->
                  <input
                    type="text"
                    class="form-control shadow-none"
                    [value]="lastFileName"
                    placeholder="No file uploaded"
                    readonly
                    style="flex: 1 1 auto; min-width: 0"
                  />

                  <!-- Hidden file input -->
                  <input
                    type="file"
                    accept="image/*,application/pdf"
                    (change)="fileChangeEventLoadingSlipAttachment($event)"
                    class="d-none"
                    id="loadingSlipAttachmentCtrl"
                    multiple
                  />

                  <!-- Upload / Add More buttons -->
                  <button
                    *ngIf="!lastFileName"
                    type="button"
                    class="btn btn-dark"
                    style="width: 100px"
                    (click)="addMoreFiles()"
                  >
                    Upload
                  </button>
                  <button
                    *ngIf="lastFileName"
                    type="button"
                    class="btn btn-dark"
                    style="width: 140px"
                    (click)="addMoreFiles()"
                  >
                    Add More
                  </button>
                </div>

                <!-- Preview thumbnails -->
                <div
                  class="d-flex flex-wrap gap-3 mt-3"
                  *ngIf="previewLoadingSlips?.length > 0"
                >
                  <div
                    *ngFor="let img of previewLoadingSlips; let i = index"
                    class="position-relative border rounded shadow-sm bg-white"
                    style="width: 120px; height: 120px; overflow: hidden"
                  >
                    <!-- Remove button -->
                    <button
                      type="button"
                      class="btn btn-sm btn-danger position-absolute"
                      style="top: 2px; right: 2px; z-index: 10; padding: 0 6px"
                      (click)="removeFile(i)"
                    >
                      &times;
                    </button>

                    <!-- Image Preview -->
                    <ng-container *ngIf="isImage(img); else pdfIcon">
                      <img
                        [src]="img"
                        alt="preview"
                        class="w-100 h-100"
                        style="object-fit: cover; border-radius: 4px"
                      />
                      <button
                        type="button"
                        class="btn btn-sm position-absolute text-white fw-semibold"
                        style="
                          bottom: 50px;
                          left: 50%;
                          transform: translateX(-50%);
                          background: rgba(0, 0, 0, 0.6);
                          border: none;
                          font-size: 12px;
                          padding: 5px 10px;
                          border-radius: 6px;
                          backdrop-filter: blur(2px);
                        "
                        (click)="viewImage(img)"
                      >
                        Preview
                      </button>
                    </ng-container>

                    <!-- PDF Preview -->
                    <ng-template #pdfIcon>
                      <div
                        class="d-flex justify-content-center align-items-center h-100"
                      >
                        <i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm position-absolute text-white fw-semibold"
                        style="
                          bottom: 50px;
                          left: 50%;
                          transform: translateX(-50%);
                          background: rgba(0, 0, 0, 0.6);
                          border: none;
                          font-size: 12px;
                          padding: 5px 10px;
                          border-radius: 6px;
                          backdrop-filter: blur(2px);
                        "
                        (click)="viewPdf(i)"
                      >
                        Preview
                      </button>
                    </ng-template>
                  </div>
                </div>

                <!-- No attachments message -->
                <div
                  class="text-muted fst-italic mt-2"
                  *ngIf="!previewLoadingSlips?.length"
                >
                  No attachments uploaded yet.
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Invoice -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-12 border-bottom pb-3 mb-3 border-gray">
              <h4 class="text-dark fw-bold mb-0">Invoice Section</h4>
            </div>
            <!-- Invoice Number -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="InvoiceNoctrl" class="form-label"
                  >Invoice No<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="InvoiceNoctrl"
                  formControlName="InvoiceNo"
                  class="form-control shadow-none"
                  placeholder="Enter the invoice number"
                  (keyup)="onKeyInvoiceNo($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.InvoiceNo.invalid && ff.InvoiceNo.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>
            <!-- Invoice Value -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="InvoiceValuectrl" class="form-label"
                  >Invoice Value<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="InvoiceValuectrl"
                  formControlName="InvoiceValue"
                  class="form-control shadow-none"
                  placeholder="Enter the total value"
                  (keyup)="onKeyInvoiceValue($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="InvoiceValue?.invalid && InvoiceValue.touched"
                >
                  Invoice Value is required
                </span>
              </div>
            </div>
            <!-- Number of Articles -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="NoofArticlectrl" class="form-label"
                  >Number of Articles<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="NoofArticlectrl"
                  formControlName="NoofArticle"
                  class="form-control shadow-none"
                  placeholder="Enter total articles"
                  (keyup)="onKeyNoofArticle($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="NoofArticle.invalid && NoofArticle.touched"
                >
                  Number of Articles is required
                </span>
              </div>
            </div>

            <!-- Weight -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="Weightctrl" class="form-label"
                  >Weight<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="Weightctrl"
                  formControlName="Weight"
                  class="form-control shadow-none"
                  placeholder="Enter total weight"
                  (keyup)="onKeyWeight($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="Weight.invalid && Weight.touched"
                >
                  Weight is required
                </span>
              </div>
            </div>
            <!-- Customer Name -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="customerNamectrl" class="form-label"
                  >Customer Name<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="customerNamectrl"
                  formControlName="customerName"
                  class="form-control shadow-none"
                  placeholder="Enter customer name"
                  (keyup)="onKeyCustomerName($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="Weight.invalid && Weight.touched"
                >
                  Customer Name is required
                </span>
              </div>
            </div>

            <!-- Proof of Delivery -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Proof of Delivery</label>
              </div>
              <div
                class="col-12 col-md-6 col-lg-4 mb-3 d-flex align-items-center"
              >
                <input
                  type="file"
                  accept="image/*,.pdf,.doc"
                  (change)="fileChangeEventAttachment($event)"
                  class="form-control me-1 shadow-none"
                  id="PODctrl"
                  formControlName="POD"
                />
                <a #showPOD [href]="podURL" target="_blank"></a>
                <button
                  (click)="previewPOD()"
                  mat-raised-button
                  matTooltip="Preview"
                  class="btn btn-dark ms-2"
                  type="submit"
                >
                  <i class="fa-solid fa-eye"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-dark ms-2"
                  style="width: 40%"
                  (click)="addInvoiceDetail()"
                >
                  {{
                    InvoiceDetails.filteredData.length === 0
                      ? "Save Invoice"
                      : "Add More"
                  }}
                </button>
              </div>
            </div>
          </div>

          <!-- Table Section -->
          <div class="row mt-3" *ngIf="InvoiceDetails.filteredData.length > 0">
            <div class="col-12 contentbox">
              <table
                mat-table
                [dataSource]="InvoiceDetails"
                class="mat-elevation-z8 w-100"
              >
                <ng-container matColumnDef="invoiceNo">
                  <th mat-header-cell *matHeaderCellDef>Invoice No.</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.InvoiceNo }}</td>
                </ng-container>

                <ng-container matColumnDef="invoiceValue">
                  <th mat-header-cell *matHeaderCellDef>Invoice Value</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.InvoiceValue }}</td>
                </ng-container>

                <ng-container matColumnDef="noOfArticle">
                  <th mat-header-cell *matHeaderCellDef>NO of Article</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.NoofArticle }}</td>
                </ng-container>

                <ng-container matColumnDef="weight">
                  <th mat-header-cell *matHeaderCellDef>Weight</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.Weight }}</td>
                </ng-container>

                <ng-container matColumnDef="customerName">
                  <th mat-header-cell *matHeaderCellDef>Customer Name</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.customerName }}</td>
                </ng-container>

                <ng-container matColumnDef="pod">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    POD
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let inv; let i = index"
                    class="text-center"
                  >
                    <button
                      type="button"
                      class="btn btn-dark btn-sm px-4"
                      (click)="preview(i)"
                    >
                      Preview
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-xl-12 text-end mt-3">
          <button
            class="btn btn-dark"
            type="button"
            (click)="resetForm()"
            mat-raised-button
          >
            Reset
          </button>
          <button
            (click)="addNewLRSubmit()"
            class="btn btn-dark ms-2"
            type="submit"
            mat-raised-button
          >
            Create LR
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
